// Contact.jsx
import React from "react";
import BackGroundImage from "../assets/backgrounds/contact.jpg";
import Navbar from "./_shared/NavBar";
import * as emailjs from "emailjs-com";
import FooterSection from "./_shared/FooterSection";

const Contact = () => {
    function sendEmail(e) {
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_s1xa23r', 'template_5o56ikg', e.target, '0cudQUPLoTK6xinSc')
            .then((result) => {
                 window.location.reload()  //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior)
            }, (error) => {
                console.log(error.text);
            });
    }

    return (
        <div className="bg-gray-100 overflow-x-hidden w-full">
            {/* Hero Section */}
            <div
                className="relative bg-cover bg-center h-96 sm:h-[30rem] md:h-[35rem] lg:h-[40rem] w-full"
                style={{backgroundImage: `url(${BackGroundImage})`}}
            >
                <Navbar/>
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                    <h1 className="font-anton text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white font-extrabold italic text-center break-words">
                        Contactez nous !
                    </h1>
                </div>
            </div>

            <section className="px-4 py-8 md:py-12 w-full">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-anton text-center mb-8 md:mb-12 italic text-green-700 break-words">
                    Nous Contacter
                </h2>

                <form className="w-full max-w-md mx-auto" onSubmit={sendEmail}>
                    <label htmlFor="underline_select" className="sr-only">Underline select</label>
                    <select id="underline_select" name="section" required
                            className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-green-700 dark:border-green-700 dark:focus:border-green-700 focus:outline-none focus:ring-0 focus:border-green-700 peer">
                        <option value="">Section concernée*</option>
                        <option value="nutonsainteveronique@gmail.com">Nutons</option>
                        <option value="meutesainteveronique@gmail.com">Louveteaux</option>
                        <option value="lutinveronique@gmail.com">Lutins</option>
                        <option value="guidesaintev@gmail.com">Guides</option>
                        <option value="scoutssteve@gmail.com">Scouts</option>
                        <option value="paul.ab.willems@skynet.be">Staff d'unité et clan</option>
                    </select>

                    <div className="relative z-0 w-full mb-5 group mt-2">
                        <input type="text" name="objet" id="floating_password"
                               className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-green-700 dark:border-green-700 dark:focus:border-green-700 focus:outline-none focus:ring-0 focus:border-green-700 peer"
                               placeholder=" " required/>
                        <label htmlFor="floating_password"
                               className="peer-focus:font-medium absolute text-sm text-green-700 dark:text-green-700 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-green-700 peer-focus:dark:text-green-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Objet *</label>
                    </div>

                    <div className="relative z-0 w-full mb-5 group mt-2">
                        <input type="text" name="mail" id="mail"
                               className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-green-700 dark:border-green-700 dark:focus:border-green-700 focus:outline-none focus:ring-0 focus:border-green-700 peer"
                               placeholder=" " required/>
                        <label htmlFor="mail"
                               className="peer-focus:font-medium absolute text-sm text-green-700 dark:text-green-700 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-green-700 peer-focus:dark:text-green-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Votre courriel *</label>
                    </div>

                    <label htmlFor="message" className="block mb-2 text-sm text-green-700 dark:text-green-700">
                        Votre message *
                    </label>
                    <textarea id="message" rows="4" name="message"
                              className="block p-2.5 w-full text-sm text-green-700 bg-white rounded-lg border border-green-700 focus:ring-green-700 focus:border-green-700 dark:bg-white dark:border-green-700 dark:placeholder-gray-400 dark:text-green-700 dark:focus:ring-green-700 dark:focus:border-green-700"
                              placeholder="Message" required></textarea>

                    <div className="flex justify-center sm:justify-start mt-4">
                        <button type="submit"
                                className="text-white bg-green-700 hover:bg-green-600 focus:ring-4 focus:outline-none focus:ring-white font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-green-700 dark:hover:bg-green-600 dark:focus:ring-white">
                            Envoyer
                        </button>
                    </div>
                </form>
            </section>

            {/* Footer Section */}
            <FooterSection/>
        </div>
    );
};

export default Contact;